<template>
  <div class="serviceGuide">
    <h1>内蒙古铁花文化产业投资有限责任公司<br />2022年福利业务供货商竞选公告</h1>
    &ensp;&ensp;&ensp;&ensp;公告发布日期：2022年8月11日<br />
    &ensp;&ensp;&ensp;&ensp;为进一步规范福利物资采购工作，加强供货商管理，按照包钢（集团）公司贸易业务高效、务实、简约、透明、合规的原则，内蒙古铁花文化产业投资有限责任公司就2022年福利业务供货商进行公开竞选，诚邀符合相应资质和能力的供货商报名参加，现将本次竞选相关事宜公告如下：<br />
    <h2>一、竞选项目名称：</h2>
    <p>内蒙古铁花文化产业投资有限责任公司2022年福利业务供应商竞选</p>
    <h2>二、竞选项目范围：</h2>
    <p>米、面、食用油、粗杂粮、猪肉、牛肉、羊肉、鸡肉、禽蛋、饮料、牛奶、调料、零食、水果、月饼等。</p>
    <p>1、所有供货商，所报商品，总数不得超过6种。</p>
    <p>2、生产厂家等直供厂商，所报商品，总数不得超过6种。</p>
    <h2>三、报名资格要求：</h2>
    <p>1、已依照中华人民共和国法律注册并领取合法有效的营业执照，有固定经营场所，能独立承担民事责任的企业法人。</p>
    <p>2、供货商应具有食品生产经营许可证（食品生产许可证或食品流通许可证或餐饮服务许可证）及食品质量安全认证证书、动物防疫合格证等有关部门出具的产品检验报告。其他需要资质的特殊行业，供货商应具备相应资质和检验材料。</p>
    <p>3、具备健全的财务会计制度和良好的商业信誉，诚实守信，在相关领域工作中无违法犯罪及其他不良记录。</p>
    <p>4、经营状况良好（没有重大违法记录、被责令停业财产被接管或冻结等状态和严重违约等情形）。</p>
    <p>5、具有完善的物流配送体系及完善的售后服务。</p>
    <h2>四、报名时需提交的材料：</h2>
    <p>1、企业营业执照副本；</p>
    <p>2、银行开户许可证；</p>
    <p>3、企业法定代表人身份证复印件；</p>
    <p>4、银行资信证明或征信报告（近三个月为有效证明）；</p>
    <p>5、工商年检报告（当年或上一年度）；</p>
    <p>6、企业法定代表人及企业股东情况说明；</p>
    <p>7、国家税务部门认定为增值税专用发票复印件；</p>
    <p>8、拟入围供货商申请表；</p>
    <p>9、提供供应产品近三个月质量检测报告；</p>
    <p>10、食品经营许可证（经营预包装食品不需要食品经营许可证除外）食品质量安全认证证书、动物防疫合格证等有关部门出具的产品检验报告。</p>
    <p>11、供货商认为有必要提供的其他资质证明。</p>
    <p>提交上述材料须用A4纸复印，注明“与原件一致”，并加盖企业公章装订成册，无法提供上述材料者不能参加竞选。</p>
    <h2>五、报名日期</h2>
    <p>报名开始日期：2022年8月11日</p>
    <p>报名截止日期：2022年8 月15日</p>
    <h2>六、报名文件获取</h2>
    <p>通过与联系人取得联系，获取报名审批表；或者到办公地点拷贝电子版。</p>
    <h2>七、报名方式</h2>
    <p>现场报名：供货商法定代表人或授权委托人前来办理，授权委托人需持供货商授权方可办理。必须携带报名表和报价表电子版以及符合要求的相关材料。</p>
    <h2>八、其他相关情况说明</h2>
    <p>1、供货商竞选基本原则是：优先直供厂家、优先知名品牌、优先同质价低、优先地区总代理。成立专门工作委员会，根据贸易业务需求，以及各供货商所报产品种类、品牌、价格等具体情况，最终选择入围供货商和入围产品。</p>
    <p>2、供货商向内蒙古铁花文化产业投资有限责任公司所报商品价格不得高于向其他本地市场区域销售商所报价格。</p>
    <p>3、在政府或包钢采购网被列入黑名单的供货商不得参与竞选。</p>
    <p>4、法定代表人或者股东、监事相互交叉的公司，只允许有一家公司报名竞选供货商。</p>
    <p>5、内蒙古铁花文化产业投资有限责任公司一经发现提供虚假材料者，当即取消入围资格，后期不再允许该供应商参与竞选。</p>
    <p>6、入围供货商须缴纳5万元保证金。</p>
    <h2>九、联系方式 </h2>
    <p>报名地址：包钢少年宫北校区（包钢宾馆临时办公地点）</p>
    <p>联 系 人：耿先生 杨女士</p>
    <p>联系电话：13847285668  13009565541</p>
    <Entry></Entry>
  </div>
</template>
<script>
import Entry from './Entry.vue'

export default {
  name: 'CampaignAnnouncement',
  components: {
    Entry
  }
}
</script>
<style lang="less" scoped>
.serviceGuide {
  font-size: 0.26rem;
  padding: 0 0.35rem 1.5rem;
  line-height: 0.46rem;
  text-align: justify;
  h1 {
    font-size: 0.36rem;
    line-height: 0.5rem;
    text-align: center;
    margin: 0.5rem 0;
  }
  h2 {
    font-size: 0.32rem;
    line-height: 0.5rem;
    text-indent: 0.6rem;
  }
  p {
    text-indent: 0.55rem;
  }
  .time {
    float: right;
  }
}
</style>
